var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackAlt = function SvgBackAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4746 20.1268C12.828 20.5513 13.4586 20.6088 13.883 20.2554C14.3074 19.902 14.365 19.2715 14.0116 18.8471L10.8082 15H16.0034C19.8694 15 23.0034 18.134 23.0034 22C23.0034 22.5523 23.4511 23 24.0034 23C24.5557 23 25.0034 22.5523 25.0034 22C25.0034 17.0295 20.974 13 16.0034 13H11.2138L14.012 9.63997C14.3654 9.21558 14.3079 8.58504 13.8835 8.23161C13.4591 7.87818 12.8286 7.93571 12.4751 8.36011L8.10852 13.6035C7.79978 13.9743 7.79976 14.5126 8.10848 14.8834L12.4746 20.1268Z",
    fill: "#61AAED"
  })));
};
export default SvgBackAlt;